<template>
  <div class="sidebar p-4">
    <!-- Encabezado del Proyecto -->
    <ProjectHeader :proyecto="proyecto" :titulos-proyectos="titulosProyectos"
      @select-project="$emit('select-project', $event)" />

    <!-- Pestañas de navegación -->
    <NavTabs :activeTab="localActiveTab" @update:activeTab="updateActiveTab" />

    <transition name="fade" mode="out-in">
      <div key="localActiveTab" class="tab-pane fade show active">
        <!-- Contenido de las pestañas -->
        <TabContent :activeTab="localActiveTab" :proyecto="proyecto" :planes-de-cultivo="planes_de_cultivo"
          @usar-plan="usarPlan" @crear-evento="crearEvento" @finalizar-evento="finalizarEvento"
          @seleccionar-evento="seleccionarEvento" @seleccionar-lote="seleccionarLote" @crear-lote="crearLote"
          @seleccionar-ver-plan="seleccionarVerPlan" />
      </div>
    </transition>


  </div>
</template>

<script>

import axios from '@/axios';
import ProjectHeader from './ProjectHeader.vue';
import NavTabs from './NavTabs.vue';
import TabContent from './TabContent.vue';

export default {
  name: 'CultivoSidebar',
  components: { ProjectHeader, NavTabs, TabContent },
  props: {
    proyecto: Object,
    titulosProyectos: Array,
    planes_de_cultivo: Array,
    activeTab: String,
    nuevoLote: Object,
  },
  data() {
    return {
      localActiveTab: this.activeTab, // Copia local de la pestaña activa
      eventoSeleccionado: null,
      eventoIdSeleccionado: null,
      loteIdSeleccionado: null,

    };
  },
  watch: {
    activeTab(newValue) {
      this.localActiveTab = newValue; // Actualiza la pestaña activa local cuando cambia en el padre
    },
    'proyecto.proyecto_evento': {
      handler(eventos) {
        if (Array.isArray(eventos) && eventos.length > 0) {
          // 1) seleccionamos el último evento
          this.eventoSeleccionado = eventos[eventos.length - 1];
          this.eventoIdSeleccionado = this.eventoSeleccionado.id;

          // 2) Cambiar a la pestaña "eventos"
          this.updateActiveTab('eventos');
        }
      },
      deep: true,      // necesario para detectar mutaciones internas del array
      immediate: false // no hace falta ejecutarlo en el primer render
    }
  },
  methods: {
    updateActiveTab(tab) {
      this.localActiveTab = tab;
      this.$emit('update:activeTabProyectoGestion', tab);

      if (tab === 'eventos') {
        // Al cambiar a eventos, limpiamos la selección de lotes
        this.loteSeleccionado = null;
        // Si hay un evento seleccionado, lo reemite para refrescar la vista
        if (this.eventoSeleccionado) {
          this.seleccionarEvento(this.eventoSeleccionado);
        }
      } else if (tab === 'lotes') {
        // Al cambiar a lotes, limpiamos la selección de eventos
        this.eventoSeleccionado = null;
        // Si hay un lote seleccionado, lo reemite
        if (this.loteSeleccionado) {
          this.seleccionarLote(this.loteSeleccionado);
        }
      } else if (tab === 'administrarProyecto') {
        this.administrarProyecto();
      } else if (tab === 'cultivo') {
        this.seleccionarVerPlan(this.planSeleccionado);
      } else if (tab === 'moverPlantasASalas') {
        this.moverPlantasASalas();
      }
    },
    seleccionarEvento(evento) {
      if (!evento) {
        this.eventoSeleccionado = evento;
        this.eventoIdSeleccionado = null;
        this.$emit('select-evento', evento);
      } else {
        this.eventoSeleccionado = evento;
        this.eventoIdSeleccionado = evento.id;
        this.$emit('select-evento', evento);
      }

    },
    seleccionarLote(lote) {
      if (!lote) {
        this.$emit('select-lote', lote);
      } else {
        this.loteIdSeleccionado = lote.id;
        this.$emit('select-lote', lote);
      }
    },
    crearLote() {
      this.$emit('create-lote', this.proyecto.id);
    },

    seleccionarVerPlan(plan) {
      this.$emit('select-verPlan', plan);
    },
    moverPlantasASalas() {
      this.$emit('select-moverPlantasASalas');
    },
    administrarProyecto() {
      this.$emit('select-administrarProyecto');
    },
    crearEvento() {
      this.$emit('create-evento', this.proyecto.id);
    },
    async finalizarEvento() {
      if (!this.eventoIdSeleccionado) {
        //  console.error('CULTIVOSIDEBAR - No se ha seleccionado ningún evento');
        return;
      }

      // Confirmación antes de finalizar el evento
      const confirmacion = confirm(
        '¡ATENCIÓN! Al finalizar el Evento, no se podrán agregar ni modificar Tareas de este Evento. ¿Estás seguro de que deseas finalizar este Evento?'
      );

      if (!confirmacion) {
        return; // Detener el proceso si el usuario cancela
      }

      try {
        // Llamada a la API para finalizar el evento
        const response = await this.$axios.put(
          `/api/proyectoEvento/finalizar/${this.eventoIdSeleccionado}`,
          {
            evento_finalizado: true,
            fecha_fin_evento: new Date().toISOString(), // Fecha actual como fecha de finalización
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        // Verificar la respuesta de la API
        if (response.status === 200) {
          alert(
            'El evento ha sido finalizado. La información de este evento ya no se puede modificar y será usada para el registro histórico de cultivos de su Club.'
          );

          // Actualizar el estado del evento seleccionado
          const evento = this.proyecto.proyecto_evento.find(
            (e) => e.id === this.eventoSeleccionado
          );
          if (evento) {
            evento.evento_finalizado = true;
          }

          // Emitir evento para actualizar el estado del proyecto
          this.$emit('evento-finalizado', this.eventoSeleccionado);
        } else {
          throw new Error('Error al finalizar el evento. Inténtalo nuevamente.');
        }
      } catch (error) {
        console.error('Error al finalizar el evento:', error);
        alert(
          'Ocurrió un error al intentar finalizar el evento. Por favor, inténtalo de nuevo.'
        );
      }
    },

    usarPlan(plan) {
      //put axios /proyecto/:proyecto_id/asociar_plan/'

      axios.put(`/api/proyecto/${this.proyecto.id}/asociar_plan/`, { plan_cultivo_id: plan.id })
        .then(response => {
          alert('Plan asociado correctamente');
          this.$emit('usar-plan', response.data);
        })
        .catch(error => {
          console.error('Error al asociar plan:', error);
        });


    },



  },
  created() {
    this.localActiveTab = 'eventos';
    this.updateActiveTab(this.localActiveTab);
  },

};

</script>


<style scoped>
/* Añade una transición suave */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.sidebar {
  width: 300px;
  /* más ancho por defecto */
  max-width: 420px;
  /* límite superior razonable */
  min-width: 320px;
  /* que no se achique demasiado */
  height: 100vh;
  /* Asegura que ocupe toda la altura de la ventana */
  overflow-y: auto;
  /* Permite el desplazamiento si el contenido es demasiado largo */
  background-color: #f8f9fa;
  /* Color de fondo opcional */
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  /* Sombra opcional */
  padding: 1.5rem;
  /* opcional para mejor separación interna */

}

@media (max-width: 767.98px) {
  .sidebar {
    padding: 0.75rem !important;
    min-height: auto !important;
    height: auto !important;
  }

  .sidebar > * {
    margin-bottom: 0.75rem !important;
  }
}

</style>